import { useSyncExternalStore } from 'react';

/** For useSyncExternalStore stores whose value is read, never watched. */
export const subscribeNever = () => () => {};
const getIsClientOnClient = () => true;
const getIsClientOnServer = () => false;

/**
 * True once rendering on the client. False on the server AND during the
 * hydration pass (React uses the server snapshot there), so markup gated on it
 * hydrates against identical server HTML. A component first mounted
 * client-side (e.g. a modal opened later) sees true on its very first render.
 *
 * Use instead of a `useState(false)` + `useEffect(() => setMounted(true))` flag.
 */
export function useIsClient(): boolean {
  return useSyncExternalStore(subscribeNever, getIsClientOnClient, getIsClientOnServer);
}
